import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Modal from '@/components/base/Modal/Modal';
// client js begin
import { checkFollowStatus } from '@/services/vipService';
import util from '@tencent/vft-common/util';
// client js end
var NotMindKey = 'welfare-not-mind-me';
export default {
  components: {
    Modal: Modal
  },
  data: function data() {
    return {
      notMindMe: false,
      show: false
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!util.getUserCache(NotMindKey)) {
                _context.next = 3;
                break;
              }
              this.toast('预约成功，秒杀开始前将通过腾讯视频VIP微信公众号提醒您');
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return checkFollowStatus();
            case 5:
              res = _context.sent;
              if (!res) {
                // 没有关注过
                this.show = true;
              } else {
                this.toast('预约成功，秒杀开始前将通过腾讯视频VIP微信公众号提醒您');
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    close: function close() {
      if (this.notMindMe) {
        util.setUserCache(NotMindKey, true);
      }
      this.show = false;
      this.$emit('close');
    }
  }
};